export default __webpack_public_path__ + "static/media/buy-now-icon.dca50400.svg";